import React from 'react';
import Image from 'next/image';

interface ExpertCardProps {
  imageSrc: string;
  name: string;

  className?: string;
}

const ExpertCard: React.FC<ExpertCardProps> = ({ imageSrc, name, className }) => {
  return (
    <div className={`flex items-center gap-2 bg-gray p-2 pr-4 rounded-full ${className}`}>
      <div className="w-12 h-12 rounded-full overflow-hidden relative">
        <Image src={imageSrc} alt={name} fill sizes="48px" className="object-cover" />
      </div>
      <span className="text-sm font-medium">{name}</span>
    </div>
  );
};

export default ExpertCard;
